export default "/assets/zoom_logo-49cf7187a1a6872ea1882b6268e575bf6738842b97169375267a3486853d7490.svg";